import { throttle } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FETCH_DATE_AFTER_SELECTION } from "../../helpers/functions";
import { useAuth } from "../../providers/AuthContext";
import Auth from "../../service/Auth";
import GameService from "../../service/gameService";
import { SectionLoader } from "../../components/ui/loaders/SectionLoader";
import SelectDropDown from "../../components/ui/SelectDropDown";
import GameReportService from "../../service/gameReportsService";
import { API_URL } from "../../helpers/constants";
import SelectedDates from "./FilterFormComponents/DateFilter";
import RoleBasedDropdowns from "./FilterFormComponents/RoleBasedDropdown";
import { ReactComponent as IconSearch } from "../../assets/icons/icon-search.svg";
import { FaMinus, FaPlus } from "react-icons/fa";

const GamingReport = () => {
  const { t } = useTranslation();
  const selectRef = useRef(null);
  const authService = new Auth(API_URL);
  const gameReportService = new GameReportService(API_URL);
  const gameService = new GameService(API_URL);
  const { user } = useAuth();
  const [selectedDate, setSelectedDate] = useState("today");
  const [selecteGroupBy, setSelectedGroupBy] = useState("agent");
  const [chosenDate, setChosenDate] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [showReportData, setShowReportData] = useState(false);
  const [transfers, setTransfers] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [selectedGameOptions, setSelectedGameOptions] = useState(null);
  const [games, setGames] = useState([]);
  const [totalGames, setTotalGames] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isUserListFetched, setIsUserListFetched] = useState(false);
  const [message, setMessage] = useState("");
  const [selectedSuperAgent, setSelectedSuperAgent] = useState(null);
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [date, setDate] = useState({ startDate: "", endDate: "" });
  const [allCreatorUsers, setAllCreatorUsers] = useState([]);
  const [gamingReportsResponse, setGamingReportsResponse] = useState([]);
  const [gamingReportLoading, setGamingReportLoading] = useState(false);
  const [userLoading, setUserLoading] = useState(false);
  const [showDataAs, setShowDataAs] = useState("agent");

  const today = new Date().toISOString().split("T")[0];

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "gray" : "black",
      borderRadius: "0.375rem",
      "&:hover": {
        borderColor: "gray", // Optional: set border color on hover
      },
    }),
  };
  const dateOptions = [
    { label: "Today", value: "today" },
    { label: "Yesterday", value: "yesterday" },
    { label: "Last 7 Days", value: "7days" },
    { label: "This Month", value: "month" },
    {
      label: (
        <span className="flex justify-between items-center">
          Custom: Choose Date
          <i className="fa fa-calendar" aria-hidden="true"></i>
        </span>
      ),
      value: "custom",
    },
  ];
  const groupByOptions = [
    { label: "Agent", value: "agent" },
    { label: "Provider", value: "provider" },
    { label: "Date", value: "date" },
  ];

  const options = [
    { value: "agent", label: "Agent" },
    { value: "superagent", label: "Super Agent" },
    { value: "opetator", label: "Opetator" },
    { value: "partner", label: "Partner" },
    { value: "player", label: "Player" },
  ];
  const handleGameChange = (option) => {
    setSelectedGameOptions(option);
    if (selectRef.current) {
      selectRef.current.blur();
    }
  };
  const productOptions = [
    { username: "Any", value: "any" },
    { username: "Casino", value: "casino" },
    { username: "Sportsbook", value: "sportsbook" },
  ];
  const productOptionsMap = productOptions.map((userOption) => ({
    value: userOption.value,
    label: userOption.username,
  }));
  const handleSelectTransOptChange = (selectedOption) => {
    setSelectedUser(selectedOption.value); // Update selected value
  };

  const fetchGames = async (inputValue, callback) => {
    if (inputValue.length < 3) {
      callback([]);
      return;
    }
    try {
      let response;
      let options = [];

      try {
        const response = await gameService.searchAllGames(inputValue);
        options = response.data
          .filter((fi) => fi.name !== user.name && fi.name.toLowerCase().includes(inputValue.toLowerCase()))
          .map((item) => ({
            value: item.gameId,
            label: item.name,
          }));
        // setGames(response.data);
        setTotalGames(response?.pagination?.total);
      } catch (error) {
        console.error("Failed to load games:", error);
      } finally {
        setLoading(false);
      }
      callback(options);
    } catch (error) {
      console.error("Error fetching users:", error);
      callback([]);

      // Handle token expiration or invalid token (401)
      if (error.response?.status === 401) {
        setMessage("Authorization failed. Please log in again.");
      } else {
        setMessage("Error fetching users. Please try again later.");
      }
    }
  };

  const fetchCreatorUsers = async () => {
    try {
      setUserLoading(true);
      let response = await authService.getAllCreaterUsersById(user?._id);
      if (response.success && Array.isArray(response.users)) {
        setAllCreatorUsers([...response.users]);
      } else {
        setUserLoading(false);
        console.error("Unexpected response structure:", response);
        setMessage("No users found.");
      }
    } catch (error) {
      setUserLoading(false);
      console.error("Error fetching users:", error);
      // Handle token expiration or invalid token (401)
      if (error.response?.status === 401) {
        setMessage("Authorization failed. Please log in again.");
        // Optional: Redirect to login page
        // navigate("/login");
      } else {
        setMessage("Error fetching users. Please try again later.");
      }
    } finally {
      setUserLoading(false);
      setIsUserListFetched(true);
    }
  };

  useEffect(() => {
    fetchCreatorUsers();
  }, []);
  useEffect(() => {
    const { startDate, endDate } = FETCH_DATE_AFTER_SELECTION(selectedDate, chosenDate);
    setDate({ ...date, startDate: startDate, endDate: endDate });
  }, [selectedDate, chosenDate]);

  const handelSearchData = async () => {
    setMessage(null);
    try {
      setGamingReportLoading(true);
      let query = `${selectedPartner?.value ? `&partnerId=${selectedPartner?.value}` : ""}${
        selectedSuperAgent?.value ? `&superAgentId=${selectedSuperAgent?.value}` : ""
      }${selectedAgent?.value ? `&agentId=${selectedAgent?.value}` : ""}${selectedPlayer?.value ? `&playerId=${selectedPlayer?.value}` : ""}${
        selectedGameOptions?.value ? `&gameId=${selectedGameOptions?.value}` : ""
      }${selecteGroupBy ? `&groupedBy=${selecteGroupBy}` : ""}`;
      const gamingReportresponse = await gameReportService.getAllGameReports({
        startDate: date.startDate,
        endDate: date.endDate,
        query: query,
      });
      if (gamingReportresponse.success && gamingReportresponse?.reports?.length) {
        setShowDataAs(selecteGroupBy);
        if (selecteGroupBy === "agent") {
          setGamingReportsResponse([
            ...gamingReportresponse?.reports.map((item) => {
              return {
                ...item,
                displayUser: false,
                users: item?.users?.map((user) => {
                  return {
                    ...user,
                    displayProvider: false,
                    providers: user?.providers?.map((pro) => {
                      return {
                        ...pro,
                        displayGames: false,
                      };
                    }),
                  };
                }),
              };
            }),
          ]);
        } else if (selecteGroupBy === "provider") {
          setGamingReportsResponse([
            ...gamingReportresponse?.reports.map((item) => {
              return {
                ...item,
                displayGames: false,
                games: item?.games?.map((game) => {
                  return {
                    ...game,
                    displayUsers: false,
                    users: game?.users,
                  };
                }),
              };
            }),
          ]);
        } else if (selecteGroupBy === "date") {
          setGamingReportsResponse([
            ...gamingReportresponse?.reports.map((item) => {
              return {
                ...item,
                displayProviders: false,
                providers: item?.providers?.map((pro) => {
                  return {
                    ...pro,
                    displayGames: false,
                    games: pro?.games?.map((game) => {
                      return {
                        ...game,
                        displayUsers: false,
                        users: game.users,
                      };
                    }),
                  };
                }),
              };
            }),
          ]);
        } else {
          setGamingReportsResponse([]);
        }
      } else {
        setGamingReportsResponse([]);
        console.error("Unexpected response structure:", gamingReportresponse);
        setMessage("No Reports found.");
      }
      setGamingReportLoading(false);
    } catch (error) {
      setGamingReportLoading(false);
      console.error("Error fetching users:", error);
      // Handle token expiration or invalid token (401)
      if (error.response?.status === 401) {
        setMessage("Authorization failed. Please log in again.");
        // Optional: Redirect to login page
        // navigate("/login");
      } else {
        setMessage("Error fetching users. Please try again later.");
      }
    } finally {
      setGamingReportLoading(false);
    }
  };
  return (
    <div className="flex flex-col w-full trasnfer-history">
      {" "}
      {/* Ensure full height */}
      <header className="rounded-lg sm:text-start text-center bg-[#474747] text-white w-full p-3">
        <h1 className="md:text-2xl text-lg font-bold md:text-left text-center">{t("Gaming Report")}</h1>
      </header>
      <div className="flex-1 pt-4">
        <div className="w-full    rounded-lg ">
          {/* Date Filter Section */}
          <SelectedDates
            title="Settlement Date"
            setSelectedDate={setSelectedDate}
            selectedDate={selectedDate}
            setCustomDate={setChosenDate}
            setShowReportData={setShowReportData}
          />
          {/* Custom Date Picker Section */}
          {/* Transfer To / From Selection Section */}
          {/* <div className="flex flex-wrap justify-center"> */}
          <div className="flex flex-col lg:flex-row space-x-0 space-y-2 lg:space-x-2 lg:space-y-0 w-full rtl:space-x-reverse">
            <div className="flex flex-row lg:flex-row w-full flex-wrap gap-2 sm:gap-0 lg:gap-4 rtl:space-x-reverse">
              <div className=" w-full sm:w-[10%] lg:w-[48%] 2xl:w-[49%]">
                <SelectDropDown
                  label="Game"
                  placeholder={"Type 3+ letters"}
                  selectedOption={selectedGameOptions ? selectedGameOptions : []}
                  loadOptions={fetchGames}
                  styles={customStyles}
                  handleChange={handleGameChange}
                  isSearchable={true}
                />
              </div>
              <div className="flex-col items-center">
                <label className="block text-md ml-3 text-[#242424]">Group By</label>
                <div className="flex items-center space-x-0.5">
                  {groupByOptions.map((option, index) => (
                    <label
                      key={option.value}
                      className={`flex items-center cursor-pointer ltr:rounded-l-lg rtl:rounded-r-lg py-2 px-4 min-w-[33.33%] lg:min-w-[120px] space-x-1.5 rtl:space-x-reverse  ${
                        selecteGroupBy === option.value ? "bg-primary/70 text-black shadow-md" : "bg-[#e2e2e2] text-gray-700"
                      } ${index === 0 ? "rounded-tl-lg rounded-bl-lg" : index === 2 ? "rounded-tr-lg rounded-br-lg" : ""}`}
                    >
                      <input
                        type="radio"
                        name="groupby"
                        value={option.value}
                        checked={selecteGroupBy === option.value}
                        onChange={() => {
                          setSelectedGroupBy(option.value);
                        }}
                        className="form-radio h-3 w-3"
                      />
                      <span className="font-bold text-sm ml-2 w-full">{option.label}</span>
                    </label>
                  ))}
                </div>
              </div>
              {/* <div className=" w-full sm:w-[10%] lg:w-[48%] 2xl:w-[49%]">
                <SelectDropDown
                  label="Product"
                  options={productOptionsMap}
                  onChange={handleSelectTransOptChange}
                  placeholder="Select an option"
                  styles={customStyles}
                  isSearchable
                  className="text-black text-sm custom-focus-reset border  shadow-none rounded-md !focus:outline-none !focus:ring-0"
                />
              </div> */}
            </div>
          </div>
          <div className="flex flex-col lg:flex-row space-x-0 rtl:space-x-reverse space-y-2 lg:space-x-4 lg:space-y-0 py-2.5 lg:py-4 w-full ">
            <div className="w-full">
              <div className="flex flex-col lg:flex-row space-x-0 space-y-2 lg:space-x-2 lg:space-y-0 w-full rtl:space-x-reverse">
                <div
                  className="flex flex-col lg:flex-row space-y-2 lg:space-y-0 w-full 
                    lg:space-x-4 rtl:space-x-reverse"
                >
                  <RoleBasedDropdowns
                    userLoading={userLoading}
                    role={user?.role}
                    customStyles={customStyles}
                    allCreatorUsers={allCreatorUsers}
                    selectedPartner={selectedPartner}
                    selectedSuperAgent={selectedSuperAgent}
                    selectedAgent={selectedAgent}
                    selectedPlayer={selectedPlayer}
                    setSelectedPartner={setSelectedPartner}
                    setSelectedSuperAgent={setSelectedSuperAgent}
                    setSelectedAgent={setSelectedAgent}
                    setSelectedPlayer={setSelectedPlayer}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* <div className="flex-col lg:flex-row w-full lg:w-[35%]">
              <label
                htmlFor="user-select"
                className="block text-md ml-3  text-[#242424]"
              >
                Transfer To / From
              </label>
              <Select
                options={trasnfOptions}
                value={trasnfOptions.find((option) => option.value === selectedUser)}
                onChange={handleSelectTransOptChange}
                placeholder="Select an option"
                styles={customStyles}
                isSearchable={false}
                className="text-black text-sm custom-focus-reset border rounded-md mt-1 !focus:outline-none !focus:ring-0 !ring-0"
              />
            </div> */}
          {/* Action Buttons */}
          <div className="lg:flex gap-3 mb-8 mt-7">
            {/* selectedGameOptions ? " text-black cursor-pointer" : */}
            <button
              // disabled={!selectedGameOptions}
              onClick={handelSearchData}
              className="bg-primary hover:bg-primary/80 p-2 text-black w-full lg:max-w-40 font-bold lg:py-2 px-11 rounded-lg"
              type="button"
            >
              {t("SEARCH")}
            </button>
            <button
              className="border border-black hover:bg-gray-300 p-2 mt-4 sm:mt-0  text-gray-700 lg:max-w-40 font-bold w-full lg:py-2 px-11 rounded-lg"
              type="reset"
              onClick={() => {
                setSelectedDate("today");
                setChosenDate("");
                setTransfers([]);
                setErrorMessage(null);
                setShowReportData(false);
                setSelectedGameOptions(null);
                setGamingReportsResponse([]);
                setSelectedAgent(null);
                setSelectedPlayer(null);
                setSelectedSuperAgent(null);
              }}
            >
              {t("RESET")}
            </button>
          </div>

          <hr className="border-t mt-5 mb-3 border-[#d4c8c8a3]" />

          {/* Transfer History Display */}
          {!gamingReportLoading ? (
            gamingReportsResponse?.length ? (
              <>
                {/* <div className="pb-3">
                <span className="flex text-sm text-black">Sort by:</span>
                <label for="sortByUser" className="space-x-2 pr-3 ml-2">
                  <input
                    type="radio"
                    name="sortByBalances"
                    checked
                    id="sortByUser"
                    value="alphabetically"
                    className="focus:ring-2 peer focus:ring-blue-500"
                  />
                  <span className="text-black text-lg font-semibold">Alphabetically</span>
                </label>
                <label for="sortByBalance" className="space-x-2">
                  <input type="radio" name="sortByBalances" id="sortByBalance" value="alphabetically" />
                  <span className="text-black text-lg font-semibold">Balance</span>
                </label>
              </div> */}
                <div className="overflow-x-scroll lg:overflow-x-auto w-full">
                  <table className="w-full table-auto agent-table  border border-gray-300 ">
                    <thead className="bg-[#474747] font-medium text-sm">
                      <tr className=" ">
                        <th className="py-2 text-left px-4 border">Group</th>
                        <th className="py-2 px-4 border text-center">Ticket No</th>
                        <th className="py-2 px-4 border text-center">Stakes</th>
                        <th className="py-2 px-4 border text-center">Payout</th>
                        <th className="py-2 px-4 border text-center">+/-</th>
                        <th className="py-2 px-4 border text-center">Margin</th>
                      </tr>
                    </thead>
                    <tbody className="text-black text-sm items-center">
                      {/* {transfers.map((transfer, index) => (
                   <tr key={index} className="hover:bg-black-100">
                     <td className="border px-4 py-2 text-center">{transfer.type}</td>
                     <td className="border px-4 py-2 text-center">{transfer.amount}</td>
                     <td className="border px-4 py-2 text-center">{new Date(transfer.date).toLocaleString()}</td>
                     <td className="border px-4 py-2 text-center">
                       {transfer.senderId ? `${transfer.senderId.username} (${transfer.senderId.role})` : "Unknown Sender"}
                     </td>
                     <td className="border px-4 py-2 text-center">
                       {transfer.receiverId ? `${transfer.receiverId.username} (${transfer.receiverId.role})` : "Unknown Receiver"}
                     </td>
                   </tr>
                 ))} */}
                      {showDataAs === "agent"
                        ? gamingReportsResponse?.length
                          ? gamingReportsResponse?.map((report, reportIndex) => {
                              return (
                                <>
                                  <tr>
                                    <td className="border text-left border-gray-300 font-bold py-3" style={{ display: "flex", alignItems: "center" }}>
                                      <div
                                        className="px-5"
                                        onClick={() => {
                                          gamingReportsResponse[reportIndex].displayUser = !gamingReportsResponse[reportIndex].displayUser;
                                          setGamingReportsResponse([...gamingReportsResponse]);
                                        }}
                                      >
                                        {report?.displayUser ? <FaMinus className="cursor-pointer" /> : <FaPlus className="cursor-pointer" />}
                                      </div>
                                      {report?.agentName}
                                    </td>
                                    <td className="border text-center border-gray-300">-</td>
                                    <td className="border text-right py-2 px-4 border-gray-300">{Number(report?.totalStake)?.toFixed(2)}</td>
                                    <td className="border text-right py-2 px-4 border-gray-300">{Number(report?.totalPayout)?.toFixed(2)}</td>
                                    <td className="border text-right py-2 px-4 border-gray-300">
                                      {(Number(report?.totalStake) - Number(report?.totalPayout))?.toFixed(2)}
                                    </td>
                                    <td className="border text-right py-2 px-4 border-gray-300">-</td>
                                  </tr>
                                  {report.displayUser && report.users.length
                                    ? report?.users?.map((user, userIndex) => {
                                        return (
                                          <>
                                            {" "}
                                            <tr>
                                              <td
                                                className="border text-left border-gray-300 font-bold py-3 pl-5"
                                                style={{ display: "flex", alignItems: "center" }}
                                              >
                                                <div
                                                  className="px-5"
                                                  onClick={() => {
                                                    gamingReportsResponse[reportIndex].users[userIndex].displayProvider =
                                                      !gamingReportsResponse[reportIndex].users[userIndex].displayProvider;
                                                    setGamingReportsResponse([...gamingReportsResponse]);
                                                  }}
                                                >
                                                  {user.displayProvider ? (
                                                    <FaMinus className="cursor-pointer" />
                                                  ) : (
                                                    <FaPlus className="cursor-pointer" />
                                                  )}
                                                </div>
                                                {user?.userName}
                                              </td>
                                              <td className="border text-center border-gray-300">-</td>
                                              <td className="border text-right py-2 px-4 border-gray-300">{Number(user?.totalStake)?.toFixed(2)}</td>
                                              <td className="border text-right py-2 px-4 border-gray-300">{Number(user?.totalPayout)?.toFixed(2)}</td>
                                              <td className="border text-right py-2 px-4 border-gray-300">
                                                {(Number(user?.totalStake) - Number(user?.totalPayout))?.toFixed(2)}
                                              </td>
                                              <td className="border text-right py-2 px-4 border-gray-300">-</td>
                                            </tr>
                                            {user.displayProvider && user.providers?.length
                                              ? user?.providers?.map((pro, proIndex) => {
                                                  return (
                                                    <>
                                                      <tr>
                                                        <td
                                                          className="border text-left border-gray-300 font-bold py-3 pl-10"
                                                          style={{ display: "flex", alignItems: "center" }}
                                                        >
                                                          <div
                                                            className="px-5"
                                                            onClick={() => {
                                                              gamingReportsResponse[reportIndex].users[userIndex].providers[proIndex].displayGames =
                                                                !gamingReportsResponse[reportIndex].users[userIndex].providers[proIndex].displayGames;
                                                              setGamingReportsResponse([...gamingReportsResponse]);
                                                            }}
                                                          >
                                                            {pro?.displayGames ? (
                                                              <FaMinus className="cursor-pointer" />
                                                            ) : (
                                                              <FaPlus className="cursor-pointer" />
                                                            )}
                                                          </div>
                                                          {pro?.providerName}
                                                        </td>
                                                        <td className="border text-center border-gray-300">-</td>
                                                        <td className="border text-right py-2 px-4 border-gray-300">
                                                          {Number(pro?.totalStake)?.toFixed(2)}
                                                        </td>
                                                        <td className="border text-right py-2 px-4 border-gray-300">
                                                          {Number(pro?.totalPayout)?.toFixed(2)}
                                                        </td>
                                                        <td className="border text-right py-2 px-4 border-gray-300">
                                                          {(Number(pro?.totalStake) - Number(pro?.totalPayout))?.toFixed(2)}
                                                        </td>
                                                        <td className="border text-right py-2 px-4 border-gray-300">-</td>
                                                      </tr>
                                                      {pro?.displayGames && pro?.games?.length
                                                        ? pro.games?.map((game) => {
                                                            return (
                                                              <tr>
                                                                <td
                                                                  className="border text-left border-gray-300 font-bold py-3 pl-16"
                                                                  style={{ display: "flex", alignItems: "center" }}
                                                                >
                                                                  <div className="px-6"></div>
                                                                  {game?.gameName}
                                                                </td>
                                                                <td className="border text-center border-gray-300">-</td>
                                                                <td className="border text-right py-2 px-4 border-gray-300">
                                                                  {Number(game?.totalStake)?.toFixed(2)}
                                                                </td>
                                                                <td className="border text-right py-2 px-4 border-gray-300">
                                                                  {Number(game?.totalPayout)?.toFixed(2)}
                                                                </td>
                                                                <td className="border text-right py-2 px-4 border-gray-300">
                                                                  {(Number(game?.totalStake) - Number(game?.totalPayout))?.toFixed(2)}
                                                                </td>
                                                                <td className="border text-right py-2 px-4 border-gray-300">-</td>
                                                              </tr>
                                                            );
                                                          })
                                                        : null}
                                                    </>
                                                  );
                                                })
                                              : null}
                                          </>
                                        );
                                      })
                                    : null}
                                </>
                              );
                            })
                          : null
                        : showDataAs === "provider"
                        ? gamingReportsResponse?.length
                          ? gamingReportsResponse?.map((report, reportIndex) => {
                              return (
                                <>
                                  <tr>
                                    <td className="border text-left border-gray-300 font-bold py-3" style={{ display: "flex", alignItems: "center" }}>
                                      <div
                                        className="px-5"
                                        onClick={() => {
                                          gamingReportsResponse[reportIndex].displayGames = !gamingReportsResponse[reportIndex].displayGames;
                                          setGamingReportsResponse([...gamingReportsResponse]);
                                        }}
                                      >
                                        {report?.displayGames ? <FaMinus className="cursor-pointer" /> : <FaPlus className="cursor-pointer" />}
                                      </div>
                                      {report?.providerName}
                                    </td>
                                    <td className="border text-center border-gray-300">-</td>
                                    <td className="border text-right py-2 px-4 border-gray-300">{Number(report?.totalStake)?.toFixed(2)}</td>
                                    <td className="border text-right py-2 px-4 border-gray-300">{Number(report?.totalPayout)?.toFixed(2)}</td>
                                    <td className="border text-right py-2 px-4 border-gray-300">
                                      {(Number(report?.totalStake) - Number(report?.totalPayout))?.toFixed(2)}
                                    </td>
                                    <td className="border text-right py-2 px-4 border-gray-300">-</td>
                                  </tr>
                                  {report.displayGames && report.games.length
                                    ? report?.games?.map((game, gameIndex) => {
                                        return (
                                          <>
                                            {" "}
                                            <tr>
                                              <td
                                                className="border text-left border-gray-300 font-bold py-3 pl-5"
                                                style={{ display: "flex", alignItems: "center" }}
                                              >
                                                <div
                                                  className="px-5"
                                                  onClick={() => {
                                                    gamingReportsResponse[reportIndex].games[gameIndex].displayUsers =
                                                      !gamingReportsResponse[reportIndex].games[gameIndex].displayUsers;
                                                    setGamingReportsResponse([...gamingReportsResponse]);
                                                  }}
                                                >
                                                  {game.displayUsers ? <FaMinus className="cursor-pointer" /> : <FaPlus className="cursor-pointer" />}
                                                </div>
                                                {game?.gameName}
                                              </td>
                                              <td className="border text-center border-gray-300">-</td>
                                              <td className="border text-right py-2 px-4 border-gray-300">{Number(game?.totalStake)?.toFixed(2)}</td>
                                              <td className="border text-right py-2 px-4 border-gray-300">{Number(game?.totalPayout)?.toFixed(2)}</td>
                                              <td className="border text-right py-2 px-4 border-gray-300">
                                                {(Number(game?.totalStake) - Number(game?.totalPayout))?.toFixed(2)}
                                              </td>
                                              <td className="border text-right py-2 px-4 border-gray-300">-</td>
                                            </tr>
                                            {game.displayUsers && game.users?.length
                                              ? game?.users?.map((user, userIndex) => {
                                                  return (
                                                    <>
                                                      <tr>
                                                        <td
                                                          className="border text-left border-gray-300 font-bold py-3 pl-10"
                                                          style={{ display: "flex", alignItems: "center" }}
                                                        >
                                                          <div className="px-5"></div>
                                                          {user?.userName}
                                                        </td>
                                                        <td className="border text-center border-gray-300">-</td>
                                                        <td className="border text-right py-2 px-4 border-gray-300">
                                                          {Number(user?.totalStake)?.toFixed(2)}
                                                        </td>
                                                        <td className="border text-right py-2 px-4 border-gray-300">
                                                          {Number(user?.totalPayout)?.toFixed(2)}
                                                        </td>
                                                        <td className="border text-right py-2 px-4 border-gray-300">
                                                          {(Number(user?.totalStake) - Number(user?.totalPayout))?.toFixed(2)}
                                                        </td>
                                                        <td className="border text-right py-2 px-4 border-gray-300">-</td>
                                                      </tr>
                                                    </>
                                                  );
                                                })
                                              : null}
                                          </>
                                        );
                                      })
                                    : null}
                                </>
                              );
                            })
                          : null
                        : showDataAs === "date"
                        ? gamingReportsResponse?.length
                          ? gamingReportsResponse?.map((report, reportIndex) => {
                              return (
                                <>
                                  <tr>
                                    <td className="border text-left border-gray-300 font-bold py-3" style={{ display: "flex", alignItems: "center" }}>
                                      <div
                                        className="px-5"
                                        onClick={() => {
                                          gamingReportsResponse[reportIndex].displayProviders = !gamingReportsResponse[reportIndex].displayProviders;
                                          setGamingReportsResponse([...gamingReportsResponse]);
                                        }}
                                      >
                                        {report?.displayProviders ? <FaMinus className="cursor-pointer" /> : <FaPlus className="cursor-pointer" />}
                                      </div>
                                      {report?.date}
                                    </td>
                                    <td className="border text-center border-gray-300">-</td>
                                    <td className="border text-right py-2 px-4 border-gray-300">{Number(report?.totalStake)?.toFixed(2)}</td>
                                    <td className="border text-right py-2 px-4 border-gray-300">{Number(report?.totalPayout)?.toFixed(2)}</td>
                                    <td className="border text-right py-2 px-4 border-gray-300">
                                      {(Number(report?.totalStake) - Number(report?.totalPayout))?.toFixed(2)}
                                    </td>
                                    <td className="border text-right py-2 px-4 border-gray-300">-</td>
                                  </tr>
                                  {report.displayProviders && report.providers.length
                                    ? report?.providers?.map((pro, proIndex) => {
                                        return (
                                          <>
                                            {" "}
                                            <tr>
                                              <td
                                                className="border text-left border-gray-300 font-bold py-3 pl-5"
                                                style={{ display: "flex", alignItems: "center" }}
                                              >
                                                <div
                                                  className="px-5"
                                                  onClick={() => {
                                                    gamingReportsResponse[reportIndex].providers[proIndex].displayGames =
                                                      !gamingReportsResponse[reportIndex].providers[proIndex].displayGames;
                                                    setGamingReportsResponse([...gamingReportsResponse]);
                                                  }}
                                                >
                                                  {pro.displayGames ? <FaMinus className="cursor-pointer" /> : <FaPlus className="cursor-pointer" />}
                                                </div>
                                                {pro?.providerName}
                                              </td>
                                              <td className="border text-center border-gray-300">-</td>
                                              <td className="border text-right py-2 px-4 border-gray-300">{Number(pro?.totalStake)?.toFixed(2)}</td>
                                              <td className="border text-right py-2 px-4 border-gray-300">{Number(pro?.totalPayout)?.toFixed(2)}</td>
                                              <td className="border text-right py-2 px-4 border-gray-300">
                                                {(Number(pro?.totalStake) - Number(pro?.totalPayout))?.toFixed(2)}
                                              </td>
                                              <td className="border text-right py-2 px-4 border-gray-300">-</td>
                                            </tr>
                                            {pro.displayGames && pro.games?.length
                                              ? pro?.games?.map((game, gameIndex) => {
                                                  return (
                                                    <>
                                                      <tr>
                                                        <td
                                                          className="border text-left border-gray-300 font-bold py-3 pl-5"
                                                          style={{ display: "flex", alignItems: "center" }}
                                                        >
                                                          <div
                                                            className="px-5"
                                                            onClick={() => {
                                                              gamingReportsResponse[reportIndex].providers[proIndex].games[gameIndex].displayUsers =
                                                                !gamingReportsResponse[reportIndex].providers[proIndex].games[gameIndex].displayUsers;
                                                              setGamingReportsResponse([...gamingReportsResponse]);
                                                            }}
                                                          >
                                                            {game.displayUsers ? (
                                                              <FaMinus className="cursor-pointer" />
                                                            ) : (
                                                              <FaPlus className="cursor-pointer" />
                                                            )}
                                                          </div>
                                                          {game?.gameName}
                                                        </td>
                                                        <td className="border text-center border-gray-300">-</td>
                                                        <td className="border text-right py-2 px-4 border-gray-300">
                                                          {Number(game?.totalStake)?.toFixed(2)}
                                                        </td>
                                                        <td className="border text-right py-2 px-4 border-gray-300">
                                                          {Number(game?.totalPayout)?.toFixed(2)}
                                                        </td>
                                                        <td className="border text-right py-2 px-4 border-gray-300">
                                                          {(Number(game?.totalStake) - Number(game?.totalPayout))?.toFixed(2)}
                                                        </td>
                                                        <td className="border text-right py-2 px-4 border-gray-300">-</td>
                                                      </tr>
                                                      {game.displayUsers && game.users?.length
                                                        ? game?.users?.map((user, userIndex) => {
                                                            return (
                                                              <>
                                                                <tr>
                                                                  <td
                                                                    className="border text-left border-gray-300 font-bold py-3 pl-10"
                                                                    style={{ display: "flex", alignItems: "center" }}
                                                                  >
                                                                    <div className="px-5"></div>
                                                                    {user?.userName}
                                                                  </td>
                                                                  <td className="border text-center border-gray-300">-</td>
                                                                  <td className="border text-right py-2 px-4 border-gray-300">
                                                                    {Number(user?.totalStake)?.toFixed(2)}
                                                                  </td>
                                                                  <td className="border text-right py-2 px-4 border-gray-300">
                                                                    {Number(user?.totalPayout)?.toFixed(2)}
                                                                  </td>
                                                                  <td className="border text-right py-2 px-4 border-gray-300">
                                                                    {(Number(user?.totalStake) - Number(user?.totalPayout))?.toFixed(2)}
                                                                  </td>
                                                                  <td className="border text-right py-2 px-4 border-gray-300">-</td>
                                                                </tr>
                                                              </>
                                                            );
                                                          })
                                                        : null}
                                                    </>
                                                  );
                                                })
                                              : null}
                                          </>
                                        );
                                      })
                                    : null}
                                </>
                              );
                            })
                          : null
                        : null}
                    </tbody>
                    <tfoot className="bg-[#808080]  text-white text-sm text-left font-semibold uppercase py-2 px-4">
                      <tr>
                        <th className="text-left py-2 px-4" colspan="2">
                          Total
                          {/* <span className="lowercase font-normal">{`(${gamingReportsResponse?.sessions?.length} Players)`}</span> */}
                        </th>
                        <th className="text-right border py-2 px-4 border-gray-300"> {user?.currency}</th>
                        <th className="text-right border py-2 px-4 border-gray-300"> {user?.currency}</th>
                        <th className="text-right border py-2 px-4 border-gray-300"> {user?.currency}</th>
                        <th className="text-right border py-2 px-4 border-gray-300">{user?.currency}</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                <div className="tickets-pagination flex flex-wrap mt-6 lg:my-6 items-center flex-col lg:flex-row">
                  <div className="text-sm text-[#242424] text-center ltr:lg:text-left rtl:lg:text-right py-2 lg:py-0">
                    Showing 1 to 2 of 4 entries
                  </div>
                </div>
              </>
            ) : (
              <div className="flex flex-col items-center justify-center py-6 px-3 my-7">
                <div className="bg-[#EDEEF5] rounded-lg p-6 sm:p-8 [&_svg_path]:fill-slate-500">
                  <IconSearch />
                </div>
                <span className="text-lg sm:text-xl mt-8 mb-4 text-[#474747] text-center w-full max-w-[300px]">
                  {t("Search all available records by selecting one of the filters above!")}
                </span>
              </div>
            )
          ) : (
            <div className="flex justify-center py-8">
              <SectionLoader bgColor="light" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GamingReport;
